'use client';

import { useMemo } from 'react';
import { useActionHook } from '@/lib/query/use-action-hook';
import type { ActionResult } from '@/types/async-protocol';

export interface FileDownloadVars {
  url: string;
  filename: string;
}

async function downloadFile(
  { url, filename }: FileDownloadVars,
  ctx?: { signal: AbortSignal },
): Promise<void> {
  if (typeof document === 'undefined') return;
  const response = await fetch(url, { signal: ctx?.signal });
  if (!response.ok) throw new Error(`Download failed: ${response.status}`);
  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);
  try {
    const anchor = document.createElement('a');
    anchor.href = objectUrl;
    anchor.download = filename;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  } finally {
    URL.revokeObjectURL(objectUrl);
  }
}

export function useFileDownload(): ActionResult<FileDownloadVars, void> {
  return useActionHook<FileDownloadVars, void>(
    useMemo(
      () => ({ mutationFn: downloadFile, abortable: true }),
      [],
    ),
  );
}
